module.exports = __webpack_public_path__ + "static/media/view1.8f089ed7.jpg";